import React, {Component} from 'react';
import Moment from 'react-moment';
import './TenderLostEvent.css';

class TenderLostEvent extends Component {
    static propTypes = {};
    static defaultProps = {};
    state = {
        data: {
            tenderNumber: '0001',
            timestamp: (new Date()).toString()
        }
    };

    render() {
        const { data, ...state } = this.state;
        return (
            <div className="widget-notifications-item">
                <div className="widget-notifications-title font-size-13 text-danger">Вы не были выбраны</div>
                <div className="widget-notifications-description font-size-13">В <a href="#">тендере № <strong>{data.tenderNumber}</strong></a> победил другой поставщик</div>
                <div className="widget-notifications-date font-size-12">
                    <Moment fromNow locale="ru">{data.timestamp}</Moment>
                </div>
                <div className="widget-notifications-icon fa fa-thumbs-down bg-danger"></div>
            </div>
        );
    }
}

export default TenderLostEvent;


// WEBPACK FOOTER //
// ./src/pages/EventsFeed/TenderLostEvent.js